import { render, staticRenderFns } from "./SemiCircle.vue?vue&type=template&id=305956cb"
import script from "./SemiCircle.vue?vue&type=script&lang=js"
export * from "./SemiCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports